export enum WebCamActionTypes {
    SET_WEBCAM_ELEMENT = '@@webcam/SET_WEBCAM_ELEMENT'
}

export interface WebCamState {
    readonly webCamElement: HTMLVideoElement;
}